import { Dispatch, SetStateAction } from 'react';

import { useAtomValue } from 'jotai';
import { WritableAtom } from 'jotai/vanilla';

import { useSetSearchAtom } from './useSetSearchAtom';

export const useSearchAtom = <AtomValue>(
    atom: WritableAtom<AtomValue, [SetStateAction<AtomValue>], void>
): [AtomValue, Dispatch<SetStateAction<AtomValue>>] => {
    const value = useAtomValue(atom);
    const dispatch = useSetSearchAtom(atom);

    return [value, dispatch];
};
